import { Form, Button } from 'react-bootstrap';
import { styled } from '@mui/material';

export const CustomFromLabel = styled(Form.Check.Label)`
  font-weight: 400;
  line-height: 19.84px;
`;

export const CustomForm = styled(Form.Check)`
  padding-left: 0;
`;

export const CustomFields = styled(Form.Group)`
  .is-invalid {
    ::placeholder {
      color: #e17171 !important;
    }
  }

  label {
    font-weight: 600;
    line-height: 17.36px;
  }

  input[type='checkbox'] {
    border: 2px solid #d8d8d8;
  }

  input[type='email'],
  input[type='text'] {
    border: 1px solid #d8d8d8;
    padding: 16px;
    height: 52px;
    border-radius: 8px;

    ::placeholder {
      font-weight: 400;
      opacity: 0.6;
    }
  }
`;

export const CustomButton = styled(Button)`
  background-color: #5650bf;
  padding: 16px 40px;
  border-radius: 6px;
  border: none;

  &:hover,
  &:active,
  &:focus {
    background-color: #453fa4;
  }
`;

export const ButtonsContainer = styled('div')`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

export const PrevStepButton = styled(Button)`
  padding: 16px 40px;
  border-radius: 6px;
  border-color: #5650bf;
`;
